import React from 'react';
import comingsoon from '../../assets/comingsoon.png'
const Blogs = () => {
    return (
        <div className='min-h-screen'>
            <img className='w-full' src={comingsoon} alt="" />
        </div>
    );
};

export default Blogs;